const componentIds = {
  Popover: 'Popover',
};

export { componentIds };
